import {isNotStringOrEmptyString} from "@utils/string";
import {isValidDateTimeString, isValidPositiveNumber} from "@utils/validators";
import {isDateGreaterThenToday} from "@utils/date-time";

export const ValidateStep3Data = (data) => {
   
   const msgList = [/*{
      name: 'halt',
      message: 'Halt'
   }*/];
   
   if(isNotStringOrEmptyString(data.previousInsurerName)) {
      msgList.push({
         name: 'previousInsurerName',
         message: 'Please specify the name of the previous insurer'
      });
   }
   
   if(isNotStringOrEmptyString(data.businessType)) {
      msgList.push({
         name: 'businessType',
         message: 'Please specify the type of business'
      });
   }
   
   if(isNotStringOrEmptyString(data.businessName)) {
      msgList.push({
         name: 'businessName',
         message: 'Please specify the name of the business, company or partnership'
      });
   }
   
   if(isNotStringOrEmptyString(data.businessCategory)) {
      msgList.push({
         name: 'businessCategory',
         message: 'Please specify the category of business'
      });
   }
   
   if('Other' === data.businessCategory) {
      
      if(isNotStringOrEmptyString(data.businessOtherCategory)) {
         msgList.push({
            name: 'businessOtherCategory',
            message: 'Please specify the other category of business'
         });
      }
      
   }
   
   if(!isValidDateTimeString(data.businessEstablishmentDate)) {
      msgList.push({
         name: 'businessEstablishmentDate',
         message: 'Please specify the date the business was established'
      });
   } else if(isDateGreaterThenToday(data.businessEstablishmentDate)) {
      
      msgList.push({
         name: 'businessEstablishmentDate',
         message: 'The date the business was established cannot be in the future!'
      });
      
   }
   
   if(isNotStringOrEmptyString(data.businessNumberOfEmployees)) {
      msgList.push({
         name: 'businessNumberOfEmployees',
         message: 'Please specify the number of employees in the business'
      });
   } else if(!isValidPositiveNumber(data.businessNumberOfEmployees,true)) {
         
         msgList.push({
             name: 'businessNumberOfEmployees',
             message: 'The number of employees in the business must be a positive number or 0!'
          });
      
   }
   
   if(isNotStringOrEmptyString(data.businessEstimatedAnnualTurnover)) {
      msgList.push({
         name: 'businessEstimatedAnnualTurnover',
         message: 'Please specify the estimated annual turnover of the business'
      });
   } else if(!isValidPositiveNumber(data.businessEstimatedAnnualTurnover,true)) {
      
      msgList.push({
         name: 'businessEstimatedAnnualTurnover',
         message: 'The estimated annual turnover of the business must be a positive number or 0!'
      });
      
   }
   
   if(isNotStringOrEmptyString(data.businessEstimatedAnnualWages)) {
      msgList.push({
         name: 'businessEstimatedAnnualWages',
         message: 'Please specify the estimated annual wages of the business'
      });
   } else if(!isValidPositiveNumber(data.businessEstimatedAnnualWages,true)) {
      
      msgList.push({
         name: 'businessEstimatedAnnualWages',
         message: 'The estimated annual wages of the business must be a positive number or 0!'
      })
   }
   
   return msgList;
   
}